module.exports = __webpack_public_path__ + "media/stylesheets/images/media/media_mobile_kurashi-e12e459b295adb63dfbb77653bb75405.png";